import { IconButton } from "@material-ui/core"
import SearchIcon from "@material-ui/icons/Search"
import type { ReactElement } from "react"

export interface ISearchButtonProps {
  type?: "submit" | "button"
  onClick?: () => void
}

export function SearchButton(props: ISearchButtonProps): ReactElement {
  const { type, onClick } = props

  return (
    <IconButton type={type ? type : "submit"} onClick={onClick}>
      <SearchIcon className="search-button-icon" />
    </IconButton>
  )
}
